module.exports = __webpack_public_path__ + "img/Arabic-06.360c256e.jpg";